import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";
import {getData} from '../../services/index';
import { Drawer,message,Collapse, Radio,Checkbox,label,Input,Popover, Button ,Tooltip,TimePicker,Select,Modal,   } from 'antd';
import { EditOutlined,PlusOutlined,DeleteOutlined,MoreOutlined } from '@ant-design/icons' ;
import $ from 'jquery';
import attached from '../../assets/images/icon/paperclip.png';
import music from '../../assets/images/icon/music.png';
import pdf_ from '../../assets/images/icon/pdf_.png';
import image from '../../assets/images/icon/image.png';
import add from '../../assets/images/icon/add.png';
import edit from '../../assets/images/icon/edit.png';
import boy from '../../assets/images/icon/boy.png';
import girl from '../../assets/images/icon/girl.png';

const { TextArea } = Input;
const { Panel } = Collapse;
const { Option } = Select;

const buttonWidth = 70;

function callback(key) {
  console.log(key);
}

function onChange(time, timeString) {
  console.log(time, timeString);
}

function onChangechecked(checkedValues) {
  console.log('checked = ', checkedValues);
}


const format = 'HH:mm a' ;
class Index extends React.Component {
	static contextTypes = {
        router: () => null
    };
	constructor(props) {
		super(props);
		this.state = {			
			employee_list : [],
			timetable_details : [],
			title : '',
			employee_id : '',
			description : '',
			date_time : new Date(),
			school_id : '',
			user_id : '',
			week_days: [],
			start_time: '',
			end_time: '',
			type: '',
			name: '',
			duration: '',
		}
		this.change_type = this.change_type.bind(this);
		this.change_days = this.change_days.bind(this);
		this.onChangeStartTime = this.onChangeStartTime.bind(this);
		this.onChangeEndTime = this.onChangeEndTime.bind(this);
		this.change_price = this.change_price.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);			
		this.handleChange = this.handleChange.bind(this);
	}
	
	

	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
		if(!localStorage.getItem('schoolData')) {
			localStorage.setItem("schoolData",'');
			localStorage.clear();
			window.location.href = '/login';
		}else{
			var storedArray = JSON.parse(localStorage.getItem("schoolData"))
			this.setState({ 
				user_id : storedArray['data'][0]['user_id'],
				school_id : storedArray['data'][0]['school_id'] ,
				id : this.props.match.params.id ,
				}
			);
		}		
		var date = new Date();
		var  currentDate = date.getFullYear() + "-" + (date.getMonth()) + "-" + date.getDate();
		this.setState({ currentDate : currentDate });
		
		this.checkData();
		
	}
	
	checkData(){
  	    if(localStorage.getItem('schoolData')){
			
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			var user_id = storedArray['data'][0]['user_id'];
			var school_id = storedArray['data'][0]['school_id'];
			
			var app = {user_id : user_id,school_id:school_id,tid:this.props.match.params.tid,id : this.props.match.params.id}

			getData('Timetable/timetable_period_details',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){				
						this.setState({
							timetable_details: result['data'],	
							start_time:  result['data'][0]['start_time'],
							end_time: result['data'][0]['end_time'],
							type: result['data'][0]['type'],
							name: result['data'][0]['period_name'],
							duration: result['data'][0]['duration'],
						});
					}else{
						this.setState({
							timetable_details: [],
						});
					}
				}
			});
		}
	}
  
  
	
	handleChange(value) {
	  this.setState({ employee_id: value });
	  document.getElementsByClassName('ant-select-selection')[0].classList.remove("error_focus");
	}
	
	handleDateChange = date => {
		this.setState({
			date_time: date
		});
	};
	

	
	
	change_days(event){
         this.setState({week_days: event});
     }
	 change_type(event){
         this.setState({type: event});
     }
	
	onChangeStartTime(time, timeString) {
	 this.setState({ start_time: timeString, });
	}
	
	onChangeEndTime(time, timeString) {
	 this.setState({ end_time: timeString });
	}
	
	change_price() {
		var valuestart = this.state.start_time;
		var valuestop =  this.state.end_time;
		var hourDiff = valuestop - valuestart; 
		$('#time').html(hourDiff); 
	  }
	  
	
	
	handleSizeChange = e => {
		this.setState({ [e.target.name]: e.target.value });
		if(e.target.name){
			document.getElementsByName(e.target.name)[0].classList.remove("error_focus");
		}
	 };
	
	handleSubmit=(e)=>{
		if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"))
			this.setState({ loading: true });
			var app = {
			school_id : storedArray['data'][0]['school_id'],
			user_id : storedArray['data'][0]['user_id'],
			id : this.props.match.params.id,
			start_time : this.state.start_time,
			end_time : this.state.end_time,
			days : this.state.week_days,
			name : this.state.name,
			duration : this.state.duration,
			type : this.state.type,
			}
			getData('Timetable/update_periods',app).then((result) => {
				if(result.status==400){
					message.config({ top: 150});
					message.error(result.error_msg,2);				
				}
				if(result.status==200){
					message.config({ top: 150});
					message.success('Task Updated',2);
					this.setState({ loading: false });
			      	window.location.href = '/time-table/edit/'+this.props.match.params.tid;    
				}
			});
		}
		else{
			message.error('Please Login',2);	
		}
	}
  
	
  
  

	render()

	{
	
		const { size } = this.state;
		
		
		return (
			<div class="mobile_view">
			
			<div id="main" class="bg-off">
         <div class="row">
		 <div class="col col-md-12  ex-padd">
            <div id="breadcrumbs-wrapper" class="bg-off">
               <div class="">
                  <div class="row no-margin">
				  <div class="col col-md-12  header-title mt-20 mh-40 iq-card">
                     <div class="col s12 m4  l4 pt-10 pb-15">
                       <h5 class="breadcrumbs-title"><span class="back_arrow" onClick={this.context.router.history.goBack}><i class="ri-arrow-left-circle-line"></i></span><span class="main_title">Edit Time Table Period</span></h5>
                     </div>
                     <div class="col s12 m8 l8 right-align-md pt-15 pb-15">
                        <ol class="breadcrumbs mb-0">
                          <li class="breadcrumb-item"><a href="/">Home</a> </li>
				
									  	 <li class="breadcrumb-item"><a href="/time-table/list">Time Table </a></li>
									  	 <li class="breadcrumb-item"><a href={`/time-table/edit/${this.props.match.params.tid}`}>Time Table Edit</a></li>
                       

                           <li class="breadcrumb-item active">Edit Period </li>
                        </ol>
                     </div>
                     </div>
                  </div>
               </div>
            </div>
		</div>	
            
            <div class="col col-md-12  ex-padd">
			
			
			{this.state.timetable_details.map((list) => ( <>
			<div class="container view-Profile child-profile">
			   <div class="col col-md-12  mb-20 card-content iq-card">
                  <section class="invoice-list-wrapper section food ">
					<div class="children mb-20  iq-card2 flow-root">
                     
					
						  
						  <div class="col col-md-12 s12 no-padd">
								
							<div class="col m6 s6 mb-20 dis-input row">
									<div class="col m4 s4 dis-input">
										<label class="mt-10 d-block"><b>Select Type :</b></label>
									</div>		
									<div class="col m8 s8 dis-input">	
										<Select onChange={this.change_type}  defaultValue={list.type}>
											<Select.Option value="period">Period</Select.Option>
											<Select.Option value="break">Break</Select.Option>
										</Select>
									</div>	
							</div>
							<div class="col m6 s6 mb-10 dis-input row">
									<div class="col m4 s4 dis-input">
										<label class="d-block mt-10"><b>Period Name :</b></label>
									</div>	
									<div class="col m8 s8 dis-input">	
										<input type="text" name="name" id="name"  defaultValue={list.period_name} onChange={this.handleSizeChange} />
									</div>
							</div>
										
						    <div class="col col-md-12 s12 mb-20 mt-40 no-padd">
								<div class="col m6 s6 dis-input row">
										<div class="col m4 s4 dis-input">
											<label class="d-block mt-10"><b>Start Time :</b></label>
										</div>	
										<div class="col m8 s8 dis-input">
											<TimePicker use12Hours format="h:mm a"  defaultValue={moment(list.start_time, format)}   onChange={this.onChangeStartTime} />
										</div>	
								</div>
								<div class="col m6 s6 mb-10 dis-input row">
										<div class="col m4 s4 dis-input">
											<label class="d-block mt-10"><b>End Time :</b></label>
										</div>		
										<div class="col m8 s8 dis-input">
											<TimePicker use12Hours format="h:mm a"  defaultValue={moment(list.end_time, format)}   onKeyUp={this.change_price} onChange={this.onChangeEndTime} />
										</div>		
								</div>
							</div>
							
							<div class="col m6 s6 mb-10 dis-input row">
									<div class="col m4 s4 dis-input">
										<label class="d-block mt-10"><b>Duration :</b></label>
									</div>			
									<div class="col m8 s8 dis-input">	
										<p name="time" class="time" id="time"><b>{list.duration}</b></p>
									</div>			
							</div>
													
						  </div>
						 
							
					</div> 
					
					
					<div class="col col-md-12 s12 meal bt pt-10 mb-10 center">
						 <Button className="snd-btn"  onClick={this.handleSubmit} loading={this.state.loading}>Submit</Button>
					</div>
                  </section>
               </div>
               <div class="content-overlay"></div>
            </div>
			</>
			))}
            </div>
         </div>
      </div>
     
			</div>
		) 
	} 
}
export default Index;
